<template>
  <main>
    <div class="container pt-4 pb-5">
      <section class="content_padding">
        <div class="row text-left" style="padding: 0.5rem; background-color: #363636;">
          <div class="col-md-8">
            <h4>2024 SANMAK Catalog 1</h4>
          </div>
          <div class="col-md-4 text-right">
            <p class="text-muted">2024-11-27</p>
          </div>
        </div>
      </section>
      <section class="content_padding mt-5">
        <h6 class="text-left ">Some quick example text to build on the card title and make up the bulk of the card's
          content.Some quick example text to build on the card title and make up the bulk of the card's
          content.Some quick example text to build on the card title and make up the bulk of the card's
          content.</h6>
        <div class="p-5">
          <img class="card-img-top" src="/assets/img/Download/PBDownload1.png" alt="Card image cap">
        </div>
        <div>
          <button class="btn custom-btn-primary" style="margin-right: 15px;min-height: 2.4rem;min-width:  8rem;">
            <img src="/assets/img/Download/Download.png" style="max-width: 1.2rem;margin: 0 0.2rem;">Download</button>
          <button class="btn" style="margin-left: 15px;min-height: 2.4rem;min-width:  8rem;">
            <img src="/assets/img/Download/Back.png" style="max-width: 1.2rem;margin: 0 0.2rem;">Back</button>
        </div>
      </section>
    </div>

  </main>
</template>

<script>
export default {
  name: 'DownloadDetails',

  computed: {

    // 获取当前路由的名称
    currentRoute() {
      return this.$route.name || '未命名路由';
    }
  },
  methods: {

  }
};
</script>

<style scoped>
@import '../../assets/css/main.css';
</style>
